// extracted by mini-css-extract-plugin
module.exports = {"topAdjustment":"CmsHero24_topAdjustment__v8Y2i","stickyCTA":"CmsHero24_stickyCTA__0FR7V"};